import type { ChartSeries } from './StackedBarChart';
import { LinePlot, type ChartScale } from './LinePlot';

// "All signals" view - one colored polyline per signal type, sharing a
// single y-axis scale so the relative volumes stay comparable.
export function MultiLineChart({
  series,
  height = 180,
  scale = 'shared',
  highlightKey = null,
  selected = [],
  onSelect,
}: {
  series: ChartSeries[];
  height?: number;
  scale?: ChartScale;
  highlightKey?: string | null;
  selected?: { key: string; index: number }[];
  onSelect?: (key: string, index: number) => void;
}) {
  return (
    <LinePlot
      series={series.map((s) => ({ key: s.name, color: s.color, values: s.values }))}
      height={height}
      scale={scale}
      highlightKey={highlightKey}
      selected={selected}
      onSelect={onSelect}
    />
  );
}
